import { addWeeks, endOfWeek, startOfWeek, subWeeks } from 'date-fns';

export type CalendarTaskWindow = { start: Date; end: Date };

export const getCalendarTaskWindow = (
  rangeStart: Date,
  rangeEnd: Date,
  bufferWeeks = 2,
): CalendarTaskWindow => ({
  start: startOfWeek(subWeeks(rangeStart, bufferWeeks)),
  end: endOfWeek(addWeeks(rangeEnd, bufferWeeks)),
});
